import { Card, CardHeader, CardContent } from '@/components/ui/card';

export default function PricingSection({ onSelectPackage }) {
  return (
    <section id="pricing" style={{ padding: '1.5rem 2rem', background: '#ffffff', scrollMarginTop: '100px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2 className="color-text" style={{ fontSize: '1.5rem', fontWeight: '600', textAlign: 'center', marginBottom: '0.5rem' }}>
          Start Free. Pay Only If You Continue.
        </h2>
        <p style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#6b7280', fontSize: '1rem' }}>
          One-time payment. No subscription. Lifetime access.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Card style={{ border: '2px solid #6366f1', display: 'flex', flexDirection: 'column', maxWidth: '550px', width: '100%' }}>
            <CardHeader style={{ borderBottom: '1px solid #e5e7eb', padding: '1.25rem', background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%)' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
                <h3 className="color-text" style={{ fontSize: '1.3rem', fontWeight: '600', margin: 0 }}>Full Access</h3>
                <span style={{ fontSize: '0.8rem', fontWeight: '600', color: '#059669', background: '#d1fae5', padding: '0.2rem 0.6rem', borderRadius: '1rem' }}>Lifetime</span>
              </div>
            </CardHeader>
            <CardContent style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', flex: 1 }}>
              <div style={{ marginBottom: '0.5rem' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '2.5rem', fontWeight: '800', color: '#6366f1' }}>$49</span>
                  <span style={{ fontSize: '1rem', fontWeight: '500', color: '#6b7280' }}>one-time</span>
                  <span style={{ fontSize: '1rem', fontWeight: '600', color: '#059669' }}>— lifetime access</span>
                </div>
                <p style={{ fontSize: '1rem', color: '#374151', margin: '0.35rem 0 0 0', fontWeight: '500' }}>
                  Pay once, study as long as you need. No subscriptions, no auto-renewals.
                </p>
              </div>

              <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', padding: '0.75rem', margin: '0.75rem 0', fontSize: '0.85rem', color: '#166534', lineHeight: '1.5' }}>
                Secure checkout via Stripe. Your account is created instantly after payment.
              </div>

              <ul className="regular-text" style={{ listStyle: 'none', padding: 0, fontSize: '0.9rem', flex: 1, marginBottom: '1.5rem', marginTop: '0.75rem' }}>
                <li style={{ marginBottom: '0.4rem' }}>&#10003; 9 full-length adaptive SAT tests (incl. diagnostic)</li>
                <li style={{ marginBottom: '0.4rem' }}>&#10003; Personalized performance analytics</li>
                <li style={{ marginBottom: '0.4rem' }}>&#10003; Calibrated score prediction with confidence band</li>
                <li style={{ marginBottom: '0.4rem' }}>&#10003; Evolving performance-based study plan</li>
                <li style={{ marginBottom: '0.4rem' }}>&#10003; Plan-aligned personalized practice</li>
                <li style={{ marginBottom: '0.4rem' }}>&#10003; Full question bank access</li>
                <li>&#10003; Step-by-step expert solutions</li>
              </ul>
              <button 
                className="w-full white-text" 
                style={{ 
                  backgroundColor: '#6366f1',
                  color: 'white',
                  padding: '0.75rem 1rem',
                  borderRadius: '0.375rem',
                  border: 'none',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  marginTop: 'auto',
                  transition: 'all 0.2s'
                }}
                onClick={() => onSelectPackage('full')}
                data-testid="choose-full-btn"
                onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                Get Lifetime Access — $49
              </button>
              <p style={{ textAlign: 'center', fontSize: '0.85rem', color: '#6b7280', margin: '0.5rem 0 0 0' }}>
                Secure payment by Stripe · Pay once, keep forever
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
